export const foodCategoriesData = [
  {
    _id: "6108dbb984834d0bd5973259",
    title: "SALAD",
    thumbnails: "https://images.unsplash.com/photo-1447078806655-40579c2520d6?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80",
    menu: [
      {
        _id: "6108dbb984834d0bd597325a",
        title: "GANESH BHEL",
        description: "Chaat, Fast Food",
        day: "Monday",
        rating: "4.1",
        thumbnails:
          "https://images.unsplash.com/photo-1504674900247-0877df9cc836?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80",
      },
      {
        _id: "6108dbb984834d0bd597325b",
        title: "GANESH BHEL",
        description: "Chaat, Fast Food",
        day: "Monday",
        rating: "4.1",
        thumbnails:
          "https://images.unsplash.com/photo-1482049016688-2d3e1b311543?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=653&q=80",
      },
      {
        _id: "6108dbb984834d0bd597325c",
        title: "GANESH BHEL",
        description: "Chaat, Fast Food",
        day: "Monday",
        rating: "4.1",
        thumbnails:
          "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80",
      },
      {
        _id: "6108dbb984834d0bd597325d",
        title: "GANESH BHEL",
        description: "Chaat, Fast Food",
        day: "Monday",
        rating: "4.1",
        thumbnails:
          "https://images.unsplash.com/photo-1627662055487-551888db3aa8?ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80",
      },
      {
        _id: "6108dbb984834d0bd597325e",
        title: "GANESH BHEL",
        description: "Chaat, Fast Food",
        day: "Monday",
        rating: "4.1",
        thumbnails:
          "https://images.unsplash.com/photo-1511690656952-34342bb7c2f2?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=700&q=80",
      },
    ],
    __v: 0,
  },
  {
    _id: "6108dbbd84834d0bd597325f",
    title: "BREAD",
    thumbnails: "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80",
    menu: [
      {
        _id: "6108dbbd84834d0bd5973260",
        title: "GANESH BHEL",
        description: "Chaat, Fast Food",
        day: "Monday",
        rating: "4.1",
        thumbnails:
          "https://images.unsplash.com/photo-1455619452474-d2be8b1e70cd?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80",
      },
      {
        _id: "6108dbbd84834d0bd5973261",
        title: "GANESH BHEL",
        description: "Chaat, Fast Food",
        day: "Monday",
        rating: "4.1",
        thumbnails:
          "https://images.unsplash.com/photo-1482049016688-2d3e1b311543?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=653&q=80",
      },
      {
        _id: "6108dbbd84834d0bd5973262",
        title: "GANESH BHEL",
        description: "Chaat, Fast Food",
        day: "Monday",
        rating: "4.1",
        thumbnails:
          "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80",
      },
      {
        _id: "6108dbbd84834d0bd5973263",
        title: "GANESH BHEL",
        description: "Chaat, Fast Food",
        day: "Monday",
        rating: "4.1",
        thumbnails:
          "https://images.unsplash.com/photo-1504674900247-0877df9cc836?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80",
      },
      {
        _id: "6108dbbd84834d0bd5973264",
        title: "GANESH BHEL",
        description: "Chaat, Fast Food",
        day: "Monday",
        rating: "4.1",
        thumbnails:
          "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80",
      },
    ],
    __v: 0,
  },
  {
    _id: "6108dbc184834d0bd5973265",
    title: "VEGETARIAN",
    thumbnails: "https://images.unsplash.com/photo-1504113888839-1c8eb50233d3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1015&q=80",
    menu: [
      {
        _id: "6108dbc184834d0bd5973266",
        title: "GANESH BHEL",
        description: "Chaat, Fast Food",
        day: "Monday",
        rating: "4.1",
        thumbnails:
          "https://images.unsplash.com/photo-1565958011703-44f9829ba187?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=701&q=80",
      },
      {
        _id: "6108dbc184834d0bd5973267",
        title: "GANESH BHEL",
        description: "Chaat, Fast Food",
        day: "Monday",
        rating: "4.1",
        thumbnails:
          "https://images.unsplash.com/photo-1511688878353-3a2f5be94cd7?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=634&q=80",
      },
      {
        _id: "6108dbc184834d0bd5973268",
        title: "GANESH BHEL",
        description: "Chaat, Fast Food",
        day: "Monday",
        rating: "4.1",
        thumbnails:
          "https://images.unsplash.com/photo-1455619452474-d2be8b1e70cd?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80",
      },
      {
        _id: "6108dbc184834d0bd5973269",
        title: "GANESH BHEL",
        description: "Chaat, Fast Food",
        day: "Monday",
        rating: "4.1",
        thumbnails:
          "https://images.unsplash.com/photo-1540189549336-e6e99c3679fe?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=634&q=80",
      },
      {
        _id: "6108dbc184834d0bd597326a",
        title: "GANESH BHEL",
        description: "Chaat, Fast Food",
        day: "Monday",
        rating: "4.1",
        thumbnails:
          "https://images.unsplash.com/photo-1532980400857-e8d9d275d858?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=634&q=80",
      },
    ],
    __v: 0,
  },
  {
    _id: "6108dbc984834d0bd597326b",
    title: "VARIED",
    thumbnails: "https://images.unsplash.com/photo-1499028344343-cd173ffc68a9?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80",
    menu: [
      {
        _id: "6108dbc984834d0bd597326c",
        title: "GANESH BHEL",
        description: "Chaat, Fast Food",
        day: "Monday",
        rating: "4.1",
        thumbnails:
          "https://images.unsplash.com/photo-1473093295043-cdd812d0e601?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80",
      },
      {
        _id: "6108dbc984834d0bd597326d",
        title: "GANESH BHEL",
        description: "Chaat, Fast Food",
        day: "Monday",
        rating: "4.1",
        thumbnails:
          "https://images.unsplash.com/photo-1499028344343-cd173ffc68a9?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1050&q=80",
      },
      {
        _id: "6108dbc984834d0bd597326e",
        title: "GANESH BHEL",
        description: "Chaat, Fast Food",
        day: "Monday",
        rating: "4.1",
        thumbnails:
          "https://images.unsplash.com/photo-1476224203421-9ac39bcb3327?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80",
      },
      {
        _id: "6108dbc984834d0bd597326f",
        title: "GANESH BHEL",
        description: "Chaat, Fast Food",
        day: "Monday",
        rating: "4.1",
        thumbnails:
          "https://images.unsplash.com/photo-1548943487-a2e4e43b4853?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80",
      },
      {
        _id: "6108dbc984834d0bd5973270",
        title: "GANESH BHEL",
        description: "Chaat, Fast Food",
        day: "Monday",
        rating: "4.1",
        thumbnails:
          "https://images.unsplash.com/photo-1482049016688-2d3e1b311543?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=653&q=80",
      },
    ],
    __v: 0,
  },
];
